import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Checkbox as ChakraCheckbox, Grid, Text } from '@chakra-ui/react';
import { getIconColor, styles } from './checkbox.styles';
import theme from '../../theme';
export var CheckboxVariant = /*#__PURE__*/ function(CheckboxVariant) {
    CheckboxVariant["OUTLINED"] = "outlined";
    CheckboxVariant["CONTAINED"] = "contained";
    CheckboxVariant["CIRCULAR_OUTLINED"] = "circularOutlined";
    CheckboxVariant["CIRCULAR_CONTAINED"] = "circularContained";
    return CheckboxVariant;
}({});
export var CheckboxSize = /*#__PURE__*/ function(CheckboxSize) {
    CheckboxSize["SM"] = "sm";
    CheckboxSize["MD"] = "md";
    CheckboxSize["LG"] = "lg";
    return CheckboxSize;
}({});
const Checkbox = ({ dataTestId, label, onChange, onClick, textColor, _className = '', checkboxColor = theme.colors.foundation[300], defaultChecked = false, disabled = false, isChecked = false, size = "md", variant = "contained", ...props })=>{
    const classes = styles(checkboxColor, variant);
    const iconColor = getIconColor(checkboxColor, variant);
    const handleGridClick = (e)=>{
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };
    return /*#__PURE__*/ _jsx(Grid, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        onClick: (e)=>{
            handleGridClick(e);
        },
        children: /*#__PURE__*/ _jsx(ChakraCheckbox, {
            isChecked: isChecked,
            isDisabled: disabled,
            size: size,
            defaultChecked: defaultChecked,
            sx: {
                ...classes,
                ..._className
            },
            iconColor: iconColor,
            onChange: onChange,
            "data-testid": dataTestId?.trim() ?? 'checkbox',
            ...props,
            children: /*#__PURE__*/ _jsx(Text, {
                noOfLines: 1,
                color: textColor ?? theme.colors.text['highEmphasis'],
                children: label
            })
        })
    });
};
Checkbox.displayName = 'Checkbox';
export { Checkbox };
